import React from 'react';
/**
 * A row of multi-select filter chips. Clicking a chip toggles it in or out of `value`.
 *
 * Selections that aren't in `options` still get a chip, tacked on after the real ones.
 * The selection is shared between swimmers while the options come from whichever swimmer
 * is open, so filtering on an event the next swimmer has never swum would otherwise hide
 * every row with no chip left to switch off.
 */
const FilterChipGroup = ({ label, options, value, onChange, renderLabel, disabled, hideWhenSingle, }) => {
    const unavailable = value.filter(v => !options.includes(v));
    if (hideWhenSingle && options.length <= 1 && unavailable.length === 0)
        return null;
    const toggle = (option) => {
        if (!onChange)
            return;
        onChange(value.includes(option) ? value.filter(v => v !== option) : [...value, option]);
    };
    return (React.createElement("div", { className: "filter-chip-group" },
        label && React.createElement("span", { className: "filter-chip-label" }, label),
        React.createElement("div", { className: "filter-toggles" },
            options.map(option => (React.createElement("button", { key: option, className: `filter-toggle ${value.includes(option) ? 'active' : ''}`, onClick: () => toggle(option), disabled: disabled }, renderLabel ? renderLabel(option) : option))),
            unavailable.map(option => (React.createElement("button", { key: option, className: "filter-toggle active filter-toggle-unavailable", onClick: () => toggle(option), disabled: disabled, title: "No matching events - click to remove this filter" }, renderLabel ? renderLabel(option) : option))))));
};
/**
 * The same chip styling as {@link FilterChipGroup}, but exactly one option is always
 * selected – clicking a chip replaces the selection rather than toggling it.
 */
export function SingleFilterChipGroup({ label, options, value, onChange, renderLabel, disabled, hideWhenSingle, }) {
    if (hideWhenSingle && options.length <= 1)
        return null;
    return (React.createElement("div", { className: "filter-chip-group" },
        label && React.createElement("span", { className: "filter-chip-label" }, label),
        React.createElement("div", { className: "filter-toggles" }, options.map(option => (React.createElement("button", { key: option, className: `filter-toggle ${value === option ? 'active' : ''}`, onClick: () => onChange(option), disabled: disabled }, renderLabel ? renderLabel(option) : option))))));
}
export default FilterChipGroup;
